var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType2Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58853 0C3.33666 4.36604 0 10.904 0 18.2203C0 31.3555 10.7506 42 24 42C37.2568 42 48 31.3555 48 18.2203C48.0075 10.904 44.6708 4.36604 39.4189 0M8.58853 0V1H8.95423M8.58853 0H39.4189M8.58853 0L9.2278 0.768978C9.136 0.845298 9.0448 0.922308 8.95423 1M8.95423 1C4.07736 5.18336 1 11.3438 1 18.2203C1 30.7943 11.294 41 24 41C36.7133 41 47 30.7945 47 18.2203V18.2192C47.007 11.3435 43.9301 5.18338 39.0532 1M8.95423 1H39.0532M39.0532 1H39.4189V0M39.0532 1C38.9627 0.922308 38.8715 0.845298 38.7797 0.768978L39.4189 0",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.75C20 11.2688 18.7688 12.5 17.25 12.5C15.7312 12.5 14.5 11.2688 14.5 9.75C14.5 8.23122 15.7312 7 17.25 7C18.7688 7 20 8.23122 20 9.75Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.5C14 21.433 12.433 23 10.5 23C8.567 23 7 21.433 7 19.5C7 17.567 8.567 16 10.5 16C12.433 16 14 17.567 14 19.5Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 30C21.5 31.933 19.933 33.5 18 33.5C16.067 33.5 14.5 31.933 14.5 30C14.5 28.067 16.067 26.5 18 26.5C19.933 26.5 21.5 28.067 21.5 30Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 19.5C27.5 21.433 25.933 23 24 23C22.067 23 20.5 21.433 20.5 19.5C20.5 17.567 22.067 16 24 16C25.933 16 27.5 17.567 27.5 19.5Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30C35 31.933 33.433 33.5 31.5 33.5C29.567 33.5 28 31.933 28 30C28 28.067 29.567 26.5 31.5 26.5C33.433 26.5 35 28.067 35 30Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19.5C41 21.433 39.433 23 37.5 23C35.567 23 34 21.433 34 19.5C34 17.567 35.567 16 37.5 16C39.433 16 41 17.567 41 19.5Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 9.75C33.5 11.2688 32.2688 12.5 30.75 12.5C29.2312 12.5 28 11.2688 28 9.75C28 8.23122 29.2312 7 30.75 7C32.2688 7 33.5 8.23122 33.5 9.75Z",
    stroke: "#183254",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2Small);
export default __webpack_public_path__ + "static/media/type2_small.04023f71c1059b607aff0b2a34966741.svg";
export { ForwardRef as ReactComponent };